import type { FulfillmentOrderLine, FulfillmentResourceMentionCandidate } from "../types";
import { parseConfirmationDayExpression } from "./confirmationEntryParser";

type RouteDay = { dayNo: number; date: string | null };
const validNumber = (value?: string | null) => !!value && /^\d{1,16}(?:\.\d{1,2})?$/.test(value);
const moneyText = (value: string) => { const [whole, fraction = ""] = value.split("."); return `${BigInt(whole)}.${fraction.padEnd(2, "0")}`; };

/** 只从当前住宿范围中读取真实服务日期，未选范围不借用其他酒店的月份。 */
export function getStayServiceDate(range: string, routeDays: RouteDay[]): string | null {
  const days = parseConfirmationDayExpression(range)?.numbers;
  if (!days?.length) return null;
  const dates = days.map((dayNo) => routeDays.find((day) => day.dayNo === dayNo)?.date);
  return dates.every((date) => date && /^\d{4}-\d{2}-\d{2}$/.test(date) && Number.isFinite(Date.parse(`${date}T00:00:00Z`)) && new Date(`${date}T00:00:00Z`).toISOString().slice(0, 10) === date) ? dates[0]! : null;
}

/** 候选默认值只用于新录入；原型的1间沿用，未知价格保留待填而不视为免费。 */
export function buildStayRoomDefaults(candidate: FulfillmentResourceMentionCandidate, range: string, routeDays: RouteDay[], lines: Partial<FulfillmentOrderLine>[]) {
  const priorNights = lines.find((line) => validNumber(line.billingCount) && Number(line.billingCount) > 0)?.billingCount;
  const days = getStayServiceDate(range, routeDays) ? parseConfirmationDayExpression(range)?.numbers.length : null;
  const nights = (priorNights || String(days || 1)).replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
  const prices = [...new Set(lines.filter((line) => line.itemSpecSnapshot === candidate.skuName && validNumber(line.unitPriceAmount)).map((line) => moneyText(line.unitPriceAmount!)))];
  const priorPrice = prices.length === 1 ? prices[0] : null;
  const referencePrice = candidate.referencePriceCurrency === "CNY" && validNumber(candidate.referenceUnitPrice) ? candidate.referenceUnitPrice : null;
  const price = priorPrice ?? referencePrice;
  const capacity = candidate.roomCapacity && candidate.roomCapacity > 0 ? `${candidate.roomCapacity}人/间` : "人数待核对";
  const source = priorPrice !== null ? "本组已录价格，请核对" : referencePrice !== null ? `${candidate.referencePriceDate || "日期未标注"} 历史参考价，请核对` : "所选酒店暂无可用参考价";
  return {
    formula: `1间×${nights}晚×${price ?? "待填"}`,
    description: `${capacity} · 默认1间×${nights}晚`,
    priceLabel: price === null ? "价格待填" : `¥${price}/间/晚`,
    sourceLabel: `${source}${!priorNights && !days ? " · 晚数待核对" : ""}`,
  };
}
